import { useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import { sessionState } from '@chainlit/react-client';

import { rewindConfirmState, RewindConfirmPayload } from '@/state/project';

export default function RewindConfirmListener() {
  const session = useRecoilValue(sessionState);
  const setPayload = useSetRecoilState(rewindConfirmState);

  useEffect(() => {
    const socket = session?.socket;
    if (!socket) return;
    const handler = (payload: RewindConfirmPayload) => {
      setPayload(payload);
    };
    const dismissHandler = () => {
      setPayload(null);
    };
    socket.on('ask_rewind_confirm', handler);
    socket.on('dismiss_rewind_confirm', dismissHandler);
    return () => {
      socket.off('ask_rewind_confirm', handler);
      socket.off('dismiss_rewind_confirm', dismissHandler);
    };
  }, [session?.socket, setPayload]);

  return null;
}
